@use "Styles/includes/variables";
@use "Styles/mixins";
@use "Styles/components/buttons";
@use "Static/icons/icomoon/style.scss";

:host {
    display: block;
    margin: 0 0 16px;

    @include mixins.min-screen(variables.$xl) {
        margin: 48px 0 16px;
    }

    .comments {
        &__wrapper {
            &.is-collapsed {
                height: 0;
                overflow: hidden;
            }
        }

        &__title {
            display: flex;
            align-items: center;
            margin: 0 0 16px;
            font-size: 16px;
            line-height: 26px;
            letter-spacing: -0.16px;
            color: mixins.get-color(text, primary);
        }

        .comments__list + .comments__title {
            margin-top: 16px;
        }

        &__title-divider {
            width: 2px;
            height: 2px;
            border-radius: 100%;
            margin: 0 5px;
            background-color: mixins.get-color(text, primary);
        }

        &__login-card {
            position: relative;
            display: flex;
            flex-direction: column;
            min-width: 0;
            word-wrap: break-word;
            background-color: #fff;
            background-clip: border-box;
            border: 1px solid rgba(0, 0, 0, 0.125);
            border-radius: 0.25rem;
        }

        &__login-card-text {
            flex: 1 1 auto;
            padding: 1.25rem;

            a {
                color: #0092db;
            }
        }

        vm-list-pagination::part(pagination) {
            justify-content: center;
        }
    }

    slot[name="form-markup"] {
        display: block;
        margin: 0 0 16px;
    }
}
